exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-box{position:relative}.component-demo{position:absolute;right:5px;top:15px}.prop-color{display:inline-block;width:10px;height:10px;border:1px solid #aaa}.changelog-version{width:110px;display:inline-block}.component-extra-links{position:relative;font-size:12px}.component-extra-links a{padding-right:10px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"autoprefixer":false,"sourceMap":false,"minimize":true}!./~/ream/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ca1f7a4","scoped":false,"hasInlineConfig":true}!./~/ream/~/vue-loader/lib/selector.js?type=styles&index=0!./en/components/v-chart.vue
// module id = 1482
// module chunks = 104